(() => {
  const containerId = "collection-variant-grid";

  const container = document.getElementById(containerId);
  if (!container) {
    return;
  }

  const grid = container.querySelector(".variant-grid");
  if (!grid) {
    return;
  }

  const makeAvailableHeightTracker = (el, prop) => {
    const update = () => {
      const rect = el.getBoundingClientRect();
      const topInViewport = Math.max(rect.top, 0);
      el.style.setProperty(
        prop,
        Math.max(window.innerHeight - topInViewport, 0) + "px",
      );
    };
    update();
    window.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update, { passive: true });
  };

  const sidebar = container.querySelector(".variant-grid__sidebar");
  if (sidebar) {
    makeAvailableHeightTracker(sidebar, "--sidebar-visible-height");
  }

  const allButtons = container.querySelectorAll(".variant-grid__filter");
  const cards = grid.querySelectorAll(".f-column");
  const defaultOrder = Array.from(cards);
  const emptyStateEl = container.querySelector(".product-grid--empty");

  const activeFilters = {};
  allButtons.forEach((btn) => {
    for (const attr of btn.attributes) {
      if (attr.name.startsWith("data-filter-")) {
        const group = attr.name.slice("data-filter-".length);
        if (!(group in activeFilters)) {
          activeFilters[group] = group === "lacing-system" ? "all" : new Set();
        }
      }
    }
  });

  const applySort = (value) => {
    const sorted = Array.from(cards);
    if (value === "price-ascending") {
      sorted.sort((a, b) => a.dataset.price - b.dataset.price);
    } else if (value === "price-descending") {
      sorted.sort((a, b) => b.dataset.price - a.dataset.price);
    } else if (value === "title-ascending") {
      sorted.sort((a, b) => a.dataset.title.localeCompare(b.dataset.title));
    } else if (value === "title-descending") {
      sorted.sort((a, b) => b.dataset.title.localeCompare(a.dataset.title));
    } else if (value === "created-ascending") {
      sorted.sort((a, b) => a.dataset.created - b.dataset.created);
    } else if (value === "created-descending") {
      sorted.sort((a, b) => b.dataset.created - a.dataset.created);
    } else {
      defaultOrder.forEach((card) => grid.appendChild(card));
      return;
    }
    sorted.forEach((card) => grid.appendChild(card));
  };

  const sortSelects = container.querySelectorAll(".variant-grid__sort-select");
  sortSelects.forEach((sortSelect) => {
    sortSelect.addEventListener("change", () => {
      applySort(sortSelect.value);
      sortSelects.forEach((s) => {
        s.value = sortSelect.value;
      });
      const params = new URLSearchParams(window.location.search);
      if (sortSelect.value === "manual") {
        params.delete("sort");
      } else {
        params.set("sort", sortSelect.value);
      }
      const qs = params.toString();
      history.replaceState(
        null,
        "",
        window.location.pathname + (qs ? "?" + qs : ""),
      );
    });
  });

  const initialSort = new URLSearchParams(window.location.search).get("sort");
  if (initialSort) {
    sortSelects.forEach((s) => {
      s.value = initialSort;
    });
    applySort(initialSort);
  }

  const syncUrl = () => {
    const params = new URLSearchParams(window.location.search);
    Object.keys(activeFilters).forEach((group) => {
      params.delete(`f.${group}`);
      const active = activeFilters[group];
      if (group === "lacing-system") {
        if (active !== "all") {
          params.set(`f.${group}`, active);
        }
      } else {
        if (active.size > 0) {
          params.set(`f.${group}`, Array.from(active).join(","));
        }
      }
    });
    const qs = params.toString();
    history.replaceState(
      null,
      "",
      window.location.pathname + (qs ? "?" + qs : ""),
    );
    // Keep the hero heading in step with the filters. Defined in
    // main-collection-variant-banner.liquid, which reads the URL we just
    // wrote — so this has to run after replaceState, not before.
    if (typeof window.updateCollectionHeading === "function") {
      window.updateCollectionHeading();
    }
  };

  const restoreFromUrl = () => {
    const params = new URLSearchParams(window.location.search);
    Object.keys(activeFilters).forEach((group) => {
      const raw = params.get(`f.${group}`);
      if (!raw) {
        return;
      }
      if (group === "lacing-system") {
        activeFilters[group] = raw;
        container
          .querySelectorAll(
            `.variant-grid__filter[data-filter-lacing-system="${raw}"]`,
          )
          .forEach((btn) => btn.classList.add("variant-grid__filter--active"));
      } else {
        raw.split(",").forEach((val) => {
          activeFilters[group].add(val);
          container
            .querySelectorAll(
              `.variant-grid__filter[data-filter-${group}="${val}"]`,
            )
            .forEach((btn) => {
              btn.classList.add("variant-grid__filter--active");
            });
        });
      }
    });
  };

  const selectedFiltersEl = container.querySelector(
    ".variant-grid__active-filters",
  );
  const pillTemplate = document.getElementById(
    `${containerId}-selected-filter`,
  );

  const clearAllFilters = () => {
    Object.keys(activeFilters).forEach((group) => {
      if (group === "lacing-system") {
        activeFilters[group] = "all";
      } else {
        activeFilters[group] = new Set();
      }
      container
        .querySelectorAll(`.variant-grid__filter[data-filter-${group}]`)
        .forEach((b) => {
          b.classList.remove("variant-grid__filter--active");
        });
    });
    update();
    syncUrl();
  };

  const emptyStateClearBtn =
    emptyStateEl &&
    emptyStateEl.querySelector(".variant-grid__clear-all-inline");
  if (emptyStateClearBtn) {
    emptyStateClearBtn.addEventListener("click", clearAllFilters);
  }

  const updateSelectedFilters = () => {
    if (!selectedFiltersEl || !pillTemplate) {
      return;
    }
    selectedFiltersEl.innerHTML = "";
    let totalActive = 0;
    Object.keys(activeFilters).forEach((group) => {
      const active = activeFilters[group];
      const vals =
        group === "lacing-system"
          ? active === "all"
            ? []
            : [active]
          : Array.from(active);
      totalActive += vals.length;
      vals.forEach((val) => {
        const activeBtn = container.querySelector(
          `.variant-grid__filter--active[data-filter-${group}="${CSS.escape(val)}"]`,
        );
        const label = (activeBtn && activeBtn.dataset.label) || val;
        const fragment = pillTemplate.content.cloneNode(true);
        const pill = fragment.querySelector(".variant-grid__active-filter");
        pill.querySelector("span").textContent = label;
        pill.addEventListener("click", () => {
          if (activeBtn) {
            activeBtn.click();
          }
        });
        selectedFiltersEl.appendChild(fragment);
      });
    });
    if (totalActive > 1) {
      const clearBtn = document.createElement("button");
      clearBtn.type = "button";
      clearBtn.className =
        "variant-grid__active-filter variant-grid__active-filter--clear-all btn";
      clearBtn.textContent = "Clear all";
      clearBtn.addEventListener("click", clearAllFilters);
      selectedFiltersEl.appendChild(clearBtn);
    }
  };

  const cardColorMatch = (card, activeColor) => {
    if (activeColor === "all") {
      return true;
    }
    try {
      return JSON.parse(card.getAttribute("data-color") || "[]").includes(
        activeColor,
      );
    } catch (e) {
      return false;
    }
  };

  const applyFilters = () => {
    cards.forEach((card) => {
      const visible = Object.keys(activeFilters).every((group) => {
        const active = activeFilters[group];
        if (group === "lacing-system") {
          return (
            active === "all" ||
            (card.getAttribute("data-lacing-system") || "") === active
          );
        }
        if (active.size === 0) {
          return true;
        }
        if (group === "color") {
          return Array.from(active).some((val) => cardColorMatch(card, val));
        }
        if (group === "activity") {
          const cardActivities = (
            card.getAttribute("data-activity") || ""
          ).split("|");
          return Array.from(active).some((val) => cardActivities.includes(val));
        }
        return Array.from(active).some(
          (val) => (card.getAttribute(`data-${group}`) || "") === val,
        );
      });
      card.hidden = !visible;
    });
  };

  const simpleMatch = (card, attr, active) =>
    !active ||
    active.size === 0 ||
    Array.from(active).some((v) => (card.getAttribute(attr) || "") === v);

  const updateGroundFeelAvailability = () => {
    const activeLacing = activeFilters["lacing-system"] || "all";
    const activeActivity = activeFilters["activity"] || new Set();
    const activeColor = activeFilters["color"] || new Set();
    const activeOnSale = activeFilters["on-sale"] || new Set();
    const activeYardSale = activeFilters["yard-sale"] || new Set();
    container
      .querySelectorAll(".variant-grid__filter[data-filter-ground-feel]")
      .forEach((btn) => {
        const val = btn.getAttribute("data-filter-ground-feel");
        if (val === "all") return;
        const hasMatch = Array.from(cards).some((card) => {
          const lacingMatch =
            activeLacing === "all" ||
            (card.getAttribute("data-lacing-system") || "") === activeLacing;
          const cardActivities = (
            card.getAttribute("data-activity") || ""
          ).split("|");
          const activityMatch =
            activeActivity.size === 0 ||
            Array.from(activeActivity).some((a) => cardActivities.includes(a));
          const colorMatch =
            activeColor.size === 0 ||
            Array.from(activeColor).some((c) => cardColorMatch(card, c));
          return (
            lacingMatch &&
            activityMatch &&
            colorMatch &&
            simpleMatch(card, "data-on-sale", activeOnSale) &&
            simpleMatch(card, "data-yard-sale", activeYardSale) &&
            (card.getAttribute("data-ground-feel") || "") === val
          );
        });
        btn.disabled = !hasMatch;
      });
  };

  const updateActivityAvailability = () => {
    const activeLacing = activeFilters["lacing-system"] || "all";
    const activeGroundFeel = activeFilters["ground-feel"] || new Set();
    const activeColor = activeFilters["color"] || new Set();
    const activeOnSale = activeFilters["on-sale"] || new Set();
    const activeYardSale = activeFilters["yard-sale"] || new Set();
    container
      .querySelectorAll(".variant-grid__filter[data-filter-activity]")
      .forEach((btn) => {
        const val = btn.getAttribute("data-filter-activity");
        const hasMatch = Array.from(cards).some((card) => {
          const lacingMatch =
            activeLacing === "all" ||
            (card.getAttribute("data-lacing-system") || "") === activeLacing;
          const groundFeelMatch =
            activeGroundFeel.size === 0 ||
            activeGroundFeel.has(card.getAttribute("data-ground-feel") || "");
          const colorMatch =
            activeColor.size === 0 ||
            Array.from(activeColor).some((c) => cardColorMatch(card, c));
          return (
            lacingMatch &&
            groundFeelMatch &&
            colorMatch &&
            simpleMatch(card, "data-on-sale", activeOnSale) &&
            simpleMatch(card, "data-yard-sale", activeYardSale) &&
            (card.getAttribute("data-activity") || "").split("|").includes(val)
          );
        });
        btn.disabled = !hasMatch;
      });
  };

  const updateColorAvailability = () => {
    const activeLacing = activeFilters["lacing-system"] || "all";
    const activeGroundFeel = activeFilters["ground-feel"] || new Set();
    const activeActivity = activeFilters["activity"] || new Set();
    const activeOnSale = activeFilters["on-sale"] || new Set();
    const activeYardSale = activeFilters["yard-sale"] || new Set();
    container
      .querySelectorAll(".variant-grid__filter[data-filter-color]")
      .forEach((btn) => {
        const val = btn.getAttribute("data-filter-color");
        const hasMatch = Array.from(cards).some((card) => {
          const lacingMatch =
            activeLacing === "all" ||
            (card.getAttribute("data-lacing-system") || "") === activeLacing;
          const groundFeelMatch =
            activeGroundFeel.size === 0 ||
            activeGroundFeel.has(card.getAttribute("data-ground-feel") || "");
          const cardActivities = (
            card.getAttribute("data-activity") || ""
          ).split("|");
          const activityMatch =
            activeActivity.size === 0 ||
            Array.from(activeActivity).some((a) => cardActivities.includes(a));
          return (
            lacingMatch &&
            groundFeelMatch &&
            activityMatch &&
            simpleMatch(card, "data-on-sale", activeOnSale) &&
            simpleMatch(card, "data-yard-sale", activeYardSale) &&
            cardColorMatch(card, val)
          );
        });
        btn.disabled = !hasMatch;
      });
  };

  const updateOnSaleAvailability = () => {
    const activeLacing = activeFilters["lacing-system"] || "all";
    const activeGroundFeel = activeFilters["ground-feel"] || new Set();
    const activeActivity = activeFilters["activity"] || new Set();
    const activeColor = activeFilters["color"] || new Set();
    const activeYardSale = activeFilters["yard-sale"] || new Set();
    container
      .querySelectorAll(".variant-grid__filter[data-filter-on-sale]")
      .forEach((btn) => {
        const val = btn.getAttribute("data-filter-on-sale");
        const hasMatch = Array.from(cards).some((card) => {
          const lacingMatch =
            activeLacing === "all" ||
            (card.getAttribute("data-lacing-system") || "") === activeLacing;
          const groundFeelMatch =
            activeGroundFeel.size === 0 ||
            activeGroundFeel.has(card.getAttribute("data-ground-feel") || "");
          const cardActivities = (
            card.getAttribute("data-activity") || ""
          ).split("|");
          const activityMatch =
            activeActivity.size === 0 ||
            Array.from(activeActivity).some((a) => cardActivities.includes(a));
          const colorMatch =
            activeColor.size === 0 ||
            Array.from(activeColor).some((c) => cardColorMatch(card, c));
          return (
            lacingMatch &&
            groundFeelMatch &&
            activityMatch &&
            colorMatch &&
            simpleMatch(card, "data-yard-sale", activeYardSale) &&
            (card.getAttribute("data-on-sale") || "") === val
          );
        });
        btn.disabled = !hasMatch;
      });
  };

  const updateYardSaleAvailability = () => {
    const activeLacing = activeFilters["lacing-system"] || "all";
    const activeGroundFeel = activeFilters["ground-feel"] || new Set();
    const activeActivity = activeFilters["activity"] || new Set();
    const activeColor = activeFilters["color"] || new Set();
    const activeOnSale = activeFilters["on-sale"] || new Set();
    container
      .querySelectorAll(".variant-grid__filter[data-filter-yard-sale]")
      .forEach((btn) => {
        const val = btn.getAttribute("data-filter-yard-sale");
        const hasMatch = Array.from(cards).some((card) => {
          const lacingMatch =
            activeLacing === "all" ||
            (card.getAttribute("data-lacing-system") || "") === activeLacing;
          const groundFeelMatch =
            activeGroundFeel.size === 0 ||
            activeGroundFeel.has(card.getAttribute("data-ground-feel") || "");
          const cardActivities = (
            card.getAttribute("data-activity") || ""
          ).split("|");
          const activityMatch =
            activeActivity.size === 0 ||
            Array.from(activeActivity).some((a) => cardActivities.includes(a));
          const colorMatch =
            activeColor.size === 0 ||
            Array.from(activeColor).some((c) => cardColorMatch(card, c));
          return (
            lacingMatch &&
            groundFeelMatch &&
            activityMatch &&
            colorMatch &&
            simpleMatch(card, "data-on-sale", activeOnSale) &&
            (card.getAttribute("data-yard-sale") || "") === val
          );
        });
        btn.disabled = !hasMatch;
      });
  };

  const updateActivityPills = () => {
    const active = activeFilters["activity"] || new Set();
    cards.forEach((card) => {
      card.querySelectorAll(".product-card__pill--activity").forEach((pill) => {
        const id = pill.getAttribute("data-activity-id");
        pill.hidden = active.size > 0 && !active.has(id);
      });
    });
  };

  const deselectDisabled = () => {
    let changed = false;
    container
      .querySelectorAll(".variant-grid__filter--active:disabled")
      .forEach((btn) => {
        for (const attr of btn.attributes) {
          if (attr.name.startsWith("data-filter-")) {
            const group = attr.name.slice("data-filter-".length);
            const val = attr.value;
            if (group === "lacing-system") {
              activeFilters["lacing-system"] = "all";
            } else {
              activeFilters[group].delete(val);
            }
            btn.classList.remove("variant-grid__filter--active");
            changed = true;
          }
        }
      });
    return changed;
  };

  const scrollToGridIfNeeded = () => {
    const firstVisible = Array.from(cards).find((c) => !c.hidden);
    if (!firstVisible) {
      return;
    }
    const rect = firstVisible.getBoundingClientRect();
    const inView = rect.top >= 0 && rect.bottom <= window.innerHeight;
    if (!inView) {
      firstVisible.scrollIntoView({ behavior: "smooth", block: "nearest" });
    }
  };

  const updateProductCount = () => {
    const countEl = container.querySelector(".collection-product-count");
    if (!countEl) return;
    const visible = Array.from(cards).filter((c) => !c.hidden).length;
    countEl.textContent =
      visible + " " + (visible === 1 ? "product" : "products");
  };

  const updateEmptyState = () => {
    if (!emptyStateEl) return;
    emptyStateEl.hidden = Array.from(cards).some((c) => !c.hidden);
  };

  const update = () => {
    applyFilters();
    updateGroundFeelAvailability();
    updateActivityAvailability();
    updateColorAvailability();
    updateOnSaleAvailability();
    updateYardSaleAvailability();
    if (deselectDisabled()) {
      applyFilters();
    }
    updateActivityPills();
    updateSelectedFilters();
    updateProductCount();
    updateEmptyState();
    scrollToGridIfNeeded();
  };

  allButtons.forEach((btn) => {
    btn.addEventListener("click", () => {
      if (btn.disabled) {
        return;
      }
      for (const attr of btn.attributes) {
        if (attr.name.startsWith("data-filter-")) {
          const group = attr.name.slice("data-filter-".length);
          const val = attr.value;
          const isActive = btn.classList.contains(
            "variant-grid__filter--active",
          );

          if (group === "lacing-system") {
            container
              .querySelectorAll(
                ".variant-grid__filter[data-filter-lacing-system]",
              )
              .forEach((b) => {
                b.classList.remove("variant-grid__filter--active");
              });
            if (isActive) {
              activeFilters["lacing-system"] = "all";
            } else {
              activeFilters["lacing-system"] = val;
              container
                .querySelectorAll(
                  `.variant-grid__filter[data-filter-lacing-system="${CSS.escape(val)}"]`,
                )
                .forEach((b) =>
                  b.classList.add("variant-grid__filter--active"),
                );
            }
          } else {
            if (isActive) {
              activeFilters[group].delete(val);
              container
                .querySelectorAll(
                  `.variant-grid__filter[data-filter-${group}="${CSS.escape(val)}"]`,
                )
                .forEach((b) =>
                  b.classList.remove("variant-grid__filter--active"),
                );
            } else {
              activeFilters[group].add(val);
              container
                .querySelectorAll(
                  `.variant-grid__filter[data-filter-${group}="${CSS.escape(val)}"]`,
                )
                .forEach((b) =>
                  b.classList.add("variant-grid__filter--active"),
                );
            }
          }

          update();
          // If selecting a lacing system left no visible results (filters valid individually
          // but incompatible in combination), clear the remaining other-group filters.
          if (group === "lacing-system" && !isActive) {
            const visibleCount = Array.from(cards).filter(
              (c) => !c.hidden,
            ).length;
            if (visibleCount === 0) {
              ["ground-feel", "activity", "color"].forEach((g) => {
                activeFilters[g] = new Set();
                container
                  .querySelectorAll(`.variant-grid__filter[data-filter-${g}]`)
                  .forEach((b) => {
                    b.classList.remove("variant-grid__filter--active");
                  });
              });
              update();
            }
          }
          syncUrl();
        }
      }
    });
  });

  restoreFromUrl();
  update();

  const gfModal = document.getElementById("PopupModal-ground-feel");
  if (gfModal) {
    const gfSelect = gfModal.querySelector(".ground-feel-scale-nav__select");

    const activateGfPanel = (panel) => {
      gfModal
        .querySelectorAll(".ground-feel-scale-nav__marker")
        .forEach((m) => {
          const isActive = m.getAttribute("data-ground-feel-tab") === panel;
          m.classList.toggle("ground-feel-scale-nav__marker--active", isActive);
          m.setAttribute("aria-selected", isActive ? "true" : "false");
        });
      gfModal.querySelectorAll(".ground-feel-tabs__panel").forEach((p) => {
        p.classList.toggle(
          "ground-feel-tabs__panel--active",
          p.getAttribute("data-ground-feel-panel") === panel,
        );
      });
      if (gfSelect) {
        gfSelect.value = panel;
      }
    };

    gfModal
      .querySelectorAll(".ground-feel-scale-nav__marker")
      .forEach((marker) => {
        marker.addEventListener("click", () => {
          activateGfPanel(marker.getAttribute("data-ground-feel-tab"));
        });
      });

    if (gfSelect) {
      gfSelect.addEventListener("change", () => {
        activateGfPanel(gfSelect.value);
      });
    }

    gfModal.addEventListener("click", (e) => {
      const btn = e.target.closest(".ground-feel-tabs__select-btn");
      if (!btn) {
        return;
      }
      const vals = new Set(
        (btn.getAttribute("data-ground-feel-values") || "")
          .split(",")
          .filter(Boolean),
      );
      container
        .querySelectorAll(
          ".variant-grid__filter--active[data-filter-ground-feel]",
        )
        .forEach((activeBtn) => {
          const v = activeBtn.getAttribute("data-filter-ground-feel");
          if (!vals.has(v)) {
            activeBtn.click();
          }
        });
      vals.forEach((val) => {
        const filterBtn = container.querySelector(
          `.variant-grid__filter[data-filter-ground-feel="${CSS.escape(val)}"]`,
        );
        if (
          filterBtn &&
          !filterBtn.disabled &&
          !filterBtn.classList.contains("variant-grid__filter--active")
        ) {
          filterBtn.click();
        }
      });
      document.getElementById("ModalClose-ground-feel").click();
    });
  }
})();

/* Merged style cards: swatch buttons toggle the color panes (image, badge,
   price, activities), the card's buy link, and data-price. When a color
   FILTER is applied, every multi-color card auto-selects a colorway that
   matches the filter, so the preview never shows a non-matching color. */
(() => {
  const container = document.getElementById("collection-variant-grid");
  if (!container) return;

  const activate = (btn) => {
    const col = btn.closest(".f-column");
    if (!col) return;
    const idx = btn.getAttribute("data-cidx");
    col
      .querySelectorAll(".pcard-color-pane, .pcard-color-price, .pcard-activities")
      .forEach((el) => {
        el.hidden = el.getAttribute("data-cidx") !== idx;
      });
    col.querySelectorAll(".pcard-color-toggle").forEach((b) => {
      b.setAttribute("aria-pressed", String(b === btn));
    });
    const link = col.querySelector("a.product-card--color-toggle");
    if (link && btn.dataset.url) link.href = btn.dataset.url;
    if (btn.dataset.price) col.dataset.price = btn.dataset.price;
  };

  const syncToColorFilter = () => {
    const active = new Set(
      [...container.querySelectorAll(
        ".variant-grid__filter--active[data-filter-color]",
      )]
        .map((b) => b.getAttribute("data-filter-color"))
        .filter((v) => v && v !== "all"),
    );
    if (!active.size) return;
    const matches = (b) => {
      try {
        return JSON.parse(b.getAttribute("data-color-refs") || "[]").some(
          (r) => active.has(r),
        );
      } catch (e) {
        return false;
      }
    };
    container.querySelectorAll(".f-column").forEach((col) => {
      const btns = [...col.querySelectorAll(".pcard-color-toggle")];
      if (btns.length < 2) return;
      const current = btns.find(
        (b) => b.getAttribute("aria-pressed") === "true",
      );
      if (current && matches(current)) return;
      const target = btns.find(matches);
      if (target) activate(target);
    });
  };

  container.addEventListener("click", (e) => {
    const btn = e.target.closest(".pcard-color-toggle");
    if (btn) {
      e.preventDefault();
      e.stopPropagation();
      activate(btn);
      return;
    }
    if (e.target.closest("[data-filter-color]")) {
      setTimeout(syncToColorFilter, 0);
    }
  });
})();
